export function buildQueryParams<T extends Record<string, unknown>>(
  query?: Partial<T>,
): URLSearchParams {
  const qs = new URLSearchParams()

  if (!query) return qs

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return

    if (typeof value === 'string' && value.includes(',')) {
      value
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean)
        .forEach((v) => {
          qs.append(key, v)
        })
      return
    }

    if (Array.isArray(value)) {
      value.forEach((v) => {
        qs.append(key, String(v))
      })
    } else if (typeof value === 'boolean') {
      qs.append(key, value ? 'true' : 'false')
    } else {
      qs.append(key, String(value))
    }
  })

  return qs
}
